import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Product {
  product_id?: number;
  unit_id?: number;
  product_description?: string;
  product_quantity?: string;
  product_price?: string;
  product_total_price?: string;
  package_id?: number;
  package_net_weight?: string;
  package_gross_weight?: string;
  total_packages?: string;
  package_type_id?: number;
  quality_specification_id?: number;
  package_material_id?: number;
  marking?: string
    attachment?: any
}

interface UpdateProductPayload {
    index: number;
    field: keyof Product;
    value: any;
}

interface ProductState {
  products: Product[];
}
  
const initialState: ProductState = {
  products: [],
};
  
const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
      updateProductField: (state, action: PayloadAction<UpdateProductPayload>) => {
        const { index, field, value } = action.payload;
  
        while (state.products.length <= index) {
          state.products.push({}); 
        }
  
     
        state.products[index][field] = value;
      },
  
      setProducts: (state, action: PayloadAction<Product[]>) => {
        state.products = action.payload;
      },
  
      clearAllFields: (state) => {
        state.products = [];
      },
    },
  });
  
  export const { updateProductField, setProducts, clearAllFields } = productSlice.actions;
  export default productSlice.reducer;
  